import React from "react";

const steps = [
    { p: 0.15, title: "Planning", desc: "Research & clarity" },
    { p: 0.35, title: "Strategy", desc: "Approach & positioning" },
    { p: 0.55, title: "Execution", desc: "Campaign rollout" },
    { p: 0.75, title: "Tracking", desc: "Measure & learn" },
    { p: 0.9, title: "Refinement", desc: "Optimize & repeat" },
];

export default function WorkflowSteps({ progress }) {
    return (
        <div className="wf-steps">
            {steps.map((s, i) => (
                <div
                    key={i}
                    className={`wf-step ${progress > s.p ? "active" : ""}`}
                    style={{ top: `${s.p * 100}%` }}
                >
                    <h3>{s.title}</h3>
                    <p>{s.desc}</p>
                </div>
            ))}
        </div>
    );
}
